import React from "react";
import { Link, withRouter } from "react-router-dom";
import { Icon, Type, Anchor } from "@ebscois/react-component-library";
import { PrevNextNavWrapper, PrevNextNav } from "./_.styled";
import {
  affordances,
  logTopicPageNavigationClicked,
} from "../../util/analytics";

const getText = (isMobile, showText) => {
  let previousText = "";
  let nextText = "";

  if (!isMobile && showText) {
    previousText = "< Previous Section";
    nextText = "Next Section >";
  }

  if (isMobile && showText) {
    previousText = "< Previous";
    nextText = "Next >";
  }

  return { previousText, nextText };
};

const PreviousNextSection = ({
  telemetryData,
  isPageBottom,
  previousAddress,
  nextAddress,
  previousHref,
  nextHref,
  isMobile,
  history,
  handleDrugDetailNav,
  location,
  isDetailsTab,
  fontSize = "md",
  showText = true,
}) => {
  const { previousText, nextText } = getText(isMobile, showText);

  const handlePrevNextHashClick = (address, type) => {
    history.push(`#${address}`);
    const direction =
      type === "previous" ? affordances.PREVIOUS : affordances.NEXT;
    logTopicPageNavigationClicked({ ...telemetryData, direction });
  };

  const handlePrevNextLinkClick = (address, type) => {
    handleDrugDetailNav(
      address,
      undefined,
      undefined,
      location.pathname,
      history
    );
    const direction =
      type === "previous" ? affordances.PREVIOUS : affordances.NEXT;
    logTopicPageNavigationClicked({ ...telemetryData, direction });
  };

  const getProps = (type) => {
    const address = type === "next" ? nextAddress : previousAddress;
    const href = type === "next" ? nextHref : previousHref;
    // if we have a address, then it is a link
    if (address) {
      return {
        as: Anchor,
        linkComponent: Link,
        onClick: () =>
          isDetailsTab
            ? handlePrevNextLinkClick(address, type)
            : handlePrevNextHashClick(address, type),
        fontSize,
        color: "anchor",
        href,
        "aria-label": `${type} section`,
      };
    } else {
      // no address, it is disabled text
      return {
        as: Type,
        fontSize,
        color: "gray400",
        "aria-hidden": "true",
      };
    }
  };

  return (
    <PrevNextNavWrapper $isPageBottom={isPageBottom}>
      <PrevNextNav {...getProps("previous")} marginRight="md">
        {isMobile && !showText && (
          <Icon
            icon={{
              glyph: "navigate_before",
              color: previousAddress ? "anchor" : "gray400",
              size: "md",
            }}
          />
        )}
        {previousText}
      </PrevNextNav>
      <PrevNextNav {...getProps("next")}>
        {nextText}
        {isMobile && !showText && (
          <Icon
            icon={{
              glyph: "navigate_next",
              color: nextAddress ? "anchor" : "gray400",
              size: "md",
            }}
          />
        )}
      </PrevNextNav>
    </PrevNextNavWrapper>
  );
};

PreviousNextSection.displayName = "PreviousNextSection";

export { PreviousNextSection as _unconnected };
export default withRouter(PreviousNextSection);
